import server from "@/api/server";

/**
 * @param {Object} param0
 * @param {string} param0.pass - Текущий пароль
 * @param {string} param0.newphone - Новый телефон
 * @param {'init' | 'apply'} param0.process
 * @param {string} param0.smsid
 * @param {string} param0.code
 */
async function changeLogin({ pass, newphone, process, smsid, code }) {
  const data = { pass, newphone, process };
  if (process === "apply") {
    data.smsid = smsid;
    data.code = code;
  }
  const res = await server.post("/agent/users/account/changelogin", data);
  return res;
}

async function changePass(pass, newpass) {
  const res = await server.post("/agent/users/account/changepass", { pass, newpass });
  return res;
}

/**
 * Список сотрудников
 * @param {Object} data
 * @param {string} data.page
 * @param {string} data.pageSize
 * @param {string} data.filter
 * @param {string} data.search_query поисковая строка для поиска в полях: ??
 */
async function getEmployes(data) {
  const res = await server.post("/agent/agent/employee/list", data);
  return res;
}

/**
 * Удалить сотрудника
 */
async function deleteEmployee(id) {
  const res = await server.post("/agent/agent/employee/remove", { id });
  return res;
}

/**
 * Добавление сотрудника
 *
 * @param {Object} data
 * @param {string} data.phone - номер телефона (маска 79***...)
 * @param {string} data.firstname - имя (только кириллица)
 * @param {string} data.surname - фамилия (только кириллица)
 * @param {string} data.pass - пароль
 * @param {string} data.email - почта
 * @param {Array} data.access - массив прав, пока нет списка. Пример: ["agent.profile.get"]
 */
async function addEmployee(data) {
  const res = await server.post("agent/agent/employee/add", data);
  return res;
}

/**
 * Список доступов для нового сотрудника
 */
async function getEmployeeAccess() {
  const res = await server.post("agent/agent/employee/acl", { type: "group/obj", obj: "employee" });
  return res;
}

/**
 * @param {Object} param0
 * @param {'init' | 'apply'} param0.process
 * @param {string} param0.smsid - идентификатор сессии (при apply)
 * @param {string} param0.code - введенный код (при apply)
 * @param {string} param0.phone - новый номер телефона (всегда)
 */
async function transferUser({ process, smsid, code, phone, pass }) {
  const data = { process, phone, pass };
  if (process === "apply") {
    data.smsid = smsid;
    data.code = code;
  }
  const res = await server.post("/agent/users/account/transfer", data);
  return res;
}

export { changeLogin, changePass, addEmployee, getEmployeeAccess, transferUser, getEmployes, deleteEmployee };
